function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.97,
    height: 14.2,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 7.1
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.2,
    width: 27.97,
    height: 21.93,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 25.165
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 36.13,
    width: 27.97,
    height: 22.11,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 47.185
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.24,
    width: 27.97,
    height: 27.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 72.2
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.16,
    width: 27.97,
    height: 28.38,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1077777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 100.35
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.54,
    width: 27.97,
    height: 28.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 128.77
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 143,
    width: 27.97,
    height: 30.72,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.593999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 158.36
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.73,
    width: 27.97,
    height: 33.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 190.25
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 206.77,
    width: 27.97,
    height: 33.6,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7969999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 223.57000000000002
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.37,
    width: 27.97,
    height: 35.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.593999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 258.35
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 276.33,
    width: 27.97,
    height: 37.15,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.593999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 294.905
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.48,
    width: 27.97,
    height: 38.32,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 332.64000000000004
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 351.79,
    width: 27.97,
    height: 40.78,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 372.18
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 392.57,
    width: 27.97,
    height: 40.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1077777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 412.99
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 433.42,
    width: 27.97,
    height: 49.86,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.593999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 458.35
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 483.28,
    width: 27.97,
    height: 50.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 508.34499999999997
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 533.4,
    width: 27.97,
    height: 52.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7969999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 559.775
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 586.15,
    width: 27.97,
    height: 56.46,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.661666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 614.38
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.61,
    width: 27.97,
    height: 57.39,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.49625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.985,
    y: 671.3050000000001
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 0,
    width: 36.64,
    height: 45.35,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1066666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.29,
    y: 22.675
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.61,
    y: 0,
    width: 36.86,
    height: 45.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1433333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 83.03999999999999,
    y: 22.675
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.46,
    y: 0,
    width: 37.82,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.36999999999999,
    y: 22.675
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.29,
    y: 0,
    width: 38.59,
    height: 45.35,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4316666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.58499999999998,
    y: 22.675
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.87,
    y: 0,
    width: 40.74,
    height: 45.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.24,
    y: 22.675
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.61,
    y: 0,
    width: 41,
    height: 45.35,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.857142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.11,
    y: 22.675
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.61,
    y: 0,
    width: 43.32,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.188571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.27000000000004,
    y: 22.675
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 302.93,
    y: 0,
    width: 44.43,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.886
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.145,
    y: 22.675
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.36,
    y: 0,
    width: 44.94,
    height: 45.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.83000000000004,
    y: 22.675
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.3,
    y: 0,
    width: 48.22,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.41,
    y: 22.675
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.53,
    y: 0,
    width: 48.5,
    height: 45.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.558333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.78,
    y: 22.675
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.03,
    y: 0,
    width: 51.67,
    height: 45.35,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.865,
    y: 22.675
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.7,
    y: 0,
    width: 52.67,
    height: 45.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.0350000000001,
    y: 22.675
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.37,
    y: 0,
    width: 52.97,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.478571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.855,
    y: 22.675
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.35,
    y: 0,
    width: 53.65,
    height: 45.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.1750000000001,
    y: 22.675
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 45.35,
    width: 53.04,
    height: 46.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1890909090909085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 68.39
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 91.43,
    width: 53.04,
    height: 46.64,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 114.75
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 138.07,
    width: 53.04,
    height: 47.47,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.911666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 161.805
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 185.55,
    width: 53.04,
    height: 48.87,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 209.985
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 234.42,
    width: 53.04,
    height: 48.98,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.442222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 258.90999999999997
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 283.4,
    width: 53.04,
    height: 49.74,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.526666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 308.27
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 333.13,
    width: 53.04,
    height: 50.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 358.18
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 383.23,
    width: 53.04,
    height: 50.83,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.647777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 408.64500000000004
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 434.06,
    width: 53.04,
    height: 51.34,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 459.73
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 485.4,
    width: 53.04,
    height: 51.49,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.581666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 511.145
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 536.89,
    width: 53.04,
    height: 52.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 563.35
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 589.81,
    width: 53.04,
    height: 53.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 616.6049999999999
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.97,
    y: 643.4,
    width: 53.04,
    height: 56.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.489999999999995,
    y: 671.6999999999999
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 45.35,
    width: 53.78,
    height: 55.99,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.89,
    y: 73.345
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.78,
    y: 45.35,
    width: 56.79,
    height: 55.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.175,
    y: 73.345
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.57,
    y: 45.35,
    width: 58.24,
    height: 55.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.69,
    y: 73.345
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.82,
    y: 45.35,
    width: 58.53,
    height: 55.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.998571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.085,
    y: 73.345
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.34,
    y: 45.35,
    width: 62.56,
    height: 55.99,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.198
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.62,
    y: 73.345
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.9,
    y: 45.35,
    width: 62.94,
    height: 55.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.37,
    y: 73.345
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.84,
    y: 45.35,
    width: 63.88,
    height: 55.99,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.78,
    y: 73.345
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.72,
    y: 45.35,
    width: 67.08,
    height: 55.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.198
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.26,
    y: 73.345
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.8,
    y: 45.35,
    width: 67.57,
    height: 55.99,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.5849999999999,
    y: 73.345
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.37,
    y: 45.35,
    width: 67.63,
    height: 55.99,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.185,
    y: 73.345
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 101.34,
    width: 66.59,
    height: 58.31,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 130.495
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 159.64,
    width: 66.59,
    height: 62.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.868571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 190.67999999999998
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 221.72,
    width: 66.59,
    height: 63.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.681999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 253.425
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 285.13,
    width: 66.59,
    height: 63.69,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 316.975
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 348.82,
    width: 66.59,
    height: 66.29,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.365555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 381.965
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 415.11,
    width: 66.59,
    height: 68.68,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 449.45000000000005
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 483.79,
    width: 66.59,
    height: 70.41,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 518.995
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 554.2,
    width: 66.59,
    height: 72.87,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 590.635
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 627.08,
    width: 66.59,
    height: 72.92,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.098333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.295,
    y: 663.5400000000001
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 101.34,
    width: 64.11,
    height: 76.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.15857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 139.39
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.7,
    y: 101.34,
    width: 64.57,
    height: 76.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.224285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.98499999999999,
    y: 139.39
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.28,
    y: 101.34,
    width: 65.42,
    height: 76.1,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.903333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.98999999999995,
    y: 139.39
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.7,
    y: 101.34,
    width: 65.9,
    height: 76.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.322222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.65,
    y: 139.39
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.6,
    y: 101.34,
    width: 68.48,
    height: 76.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.848000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.84000000000003,
    y: 139.39
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.08,
    y: 101.34,
    width: 74.26,
    height: 76.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.21,
    y: 139.39
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.33,
    y: 101.34,
    width: 74.36,
    height: 76.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.393333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.51,
    y: 139.39
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.69,
    y: 101.34,
    width: 75.31,
    height: 76.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.551666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.345,
    y: 139.39
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 177.44,
    width: 82.83,
    height: 70.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.032
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 212.51999999999998
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 247.6,
    width: 82.83,
    height: 71.23,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.8075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 283.215
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 318.83,
    width: 82.83,
    height: 71.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.228571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 354.63
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 390.43,
    width: 82.83,
    height: 73.5,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 427.18
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 463.94,
    width: 82.83,
    height: 75.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.44375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 501.715
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 539.48,
    width: 82.83,
    height: 76.27,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.53375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 577.615
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 615.75,
    width: 82.83,
    height: 84.25,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.015,
    y: 657.875
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 177.44,
    width: 89.07,
    height: 78.34,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.96500000000003,
    y: 216.61
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.5,
    y: 177.44,
    width: 89.29,
    height: 78.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.668000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.145,
    y: 216.61
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.79,
    y: 177.44,
    width: 95.32,
    height: 78.34,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8340000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.45000000000005,
    y: 216.61
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.11,
    y: 177.44,
    width: 96.35,
    height: 78.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.191428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.285,
    y: 216.61
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.46,
    y: 177.44,
    width: 99.54,
    height: 78.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.23,
    y: 216.61
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 255.78,
    width: 101.81,
    height: 77.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.73625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.33500000000004,
    y: 294.725
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 333.67,
    width: 101.81,
    height: 82.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.458181818181819
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.33500000000004,
    y: 374.69
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 415.71,
    width: 101.81,
    height: 86.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.677
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.33500000000004,
    y: 459.09499999999997
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 502.48,
    width: 101.81,
    height: 98.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.33500000000004,
    y: 551.745
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.43,
    y: 601.01,
    width: 101.81,
    height: 98.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.141428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.33500000000004,
    y: 650.505
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.24,
    y: 255.78,
    width: 110.31,
    height: 94.27,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.78375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 387.395,
    y: 302.915
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.55,
    y: 255.78,
    width: 117.27,
    height: 94.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.78375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 501.185,
    y: 302.915
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.83,
    y: 255.78,
    width: 140.17,
    height: 94.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.711666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.9150000000001,
    y: 302.915
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.24,
    y: 350.05,
    width: 138.93,
    height: 95.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.853333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.70500000000004,
    y: 397.61
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.24,
    y: 445.17,
    width: 138.93,
    height: 105.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.70500000000004,
    y: 497.985
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.24,
    y: 550.8,
    width: 138.93,
    height: 149.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 34.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.70500000000004,
    y: 625.4
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.17,
    y: 350.05,
    width: 101.79,
    height: 204.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.541428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.065,
    y: 452.525
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.96,
    y: 350.05,
    width: 127.04,
    height: 204.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.48,
    y: 452.525
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.17,
    y: 555,
    width: 228.83,
    height: 145,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.181818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.585,
    y: 627.5
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.18c3d26c175508f7671e77ee1239e17a.svg";
export { ForwardRef as ReactComponent };